// extracted by mini-css-extract-plugin
export default {"botao":"BotaoTabela_botao__RRsJp","ativo":"BotaoTabela_ativo__17xj5","tooltip":"BotaoTabela_tooltip__Y6bG9"};